import {Injectable} from '@angular/core';
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class MobileDeviceSessionService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/ct/mobileDeviceSessions')
    }

    getObjectIcon(): string {
        return 'fa-solid fa-mobile-screen';
    }

    /**
     * Gets all active sessions.
     */
    getActiveSessions(): Observable<any[]> {
        return this.http.get<any[]>(`${this.apiUrl}/active`);
    }

    /**
     * Gets sessions for an agent.
     */
    getSessionsByAgent(agentId: number): Observable<any[]> {
        return this.http.get<any[]>(`${this.apiUrl}/by-agent/${agentId}`);
    }

    /**
     * Gets sessions with pending changes.
     */
    getSessionsWithPendingChanges(): Observable<any[]> {
        return this.http.get<any[]>(`${this.apiUrl}/pending-sync`);
    }
}
